// extracted by mini-css-extract-plugin
export var actions = "_n6-5";
export var assistantBubble = "_n6-3";
export var assistantRow = "_n6-6";
export var bubble = "_n6-0";
export var humanAvatar = "_n6-4";
export var inlineToolCard = "_n6-1";
export var userBubble = "_n6-2";